// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/ushv-ccoh/document-mappings.yaml
// Run: bun run scripts/mappings/ushv-ccoh-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const USHV_CCOH_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Patient Assistance Forms",
    documentLabel: "{{dateReceived}} Patient Assistance Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "ushv-ccoh"
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Certificate of Medical Necessity",
    documentLabel: "{{dateReceived}} Certificate of Medical Necessity",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "ushv-ccoh"
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Reyes,Leslie",
    displayName: "Disability Paperwork",
    documentLabel: "{{dateReceived}} Disability Paperwork",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "ushv-ccoh"
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Patient Medication Questionnaires",
    documentLabel: "{{dateReceived}} Patient Medication Questionnaire",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "ushv-ccoh"
  },
  [Classification.ADMIN_TRANSITION_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Transition of Care (TDC)",
    documentLabel: "{{dateReceived}} Transition of Care",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_TRANSITION_CARE,
    group: "ushv-ccoh"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cardiac Clearance Request",
    documentLabel: "{{dateOfEvent}} Clearance Request",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ushv-ccoh"
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "ID/DL/Passport",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Leg Images, Venous Post/Reflux Study Report",
    documentLabel: "{{dateOfEvent}} Leg Imaging Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_COLONOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Colonoscopy Report",
    documentLabel: "{{dateOfEvent}} Colonoscopy Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_COLONOSCOPY,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Computed Tomography, CT scans (not ordered by our physicians), CTA scans, Heart Scan, Heart Scan Plus",
    documentLabel: "{{dateOfEvent}} CT Scan Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Echocardiogram Reports",
    documentLabel: "{{dateOfEvent}} Echo Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_ENDOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Reyes,Leslie",
    displayName: "Endoscopy Report",
    documentLabel: "{{dateOfEvent}} Endoscopy Report",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ENDOSCOPY,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Holter Event Monitor Reports",
    documentLabel: "{{dateOfEvent}} Holter Event Monitor Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Mammogram Report",
    documentLabel: "{{dateOfEvent}} Mammogram Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "MRI Report",
    documentLabel: "{{dateOfEvent}} MRI Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Exercise Treadmill Report (not ordered by our physicians)",
    documentLabel: "{{dateOfEvent}} Exercise Treadmill Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Nuclear Cardiology Lexiscan Report (not ordered by our physicians)",
    documentLabel: "{{dateOfEvent}} Nuclear Cardiology Lexiscan Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_NM,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Outside Ultrasound Reports, Ultrasound Reports Signed by our Physicians",
    documentLabel: "{{dateOfEvent}} Ultrasound Report",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ushv-ccoh"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "X-Rays",
    documentLabel: "{{dateOfEvent}} X-Ray Report",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ushv-ccoh"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Insurance cards",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "ushv-ccoh"
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Patient Demographics",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "ushv-ccoh"
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Fax confirmation cover sheets, medication alerts/advisories, pharmacy notices, Rx referrals",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "ushv-ccoh"
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "BP Logs",
    documentLabel: "{{dateOfEvent}} BP Log",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ushv-ccoh"
  },
  [Classification.LAB_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Lab results (not by our physicians), Lab results (ordered by our physicians)",
    documentLabel: "{{collectionDate}} Lab Results",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_OTHER,
    group: "ushv-ccoh"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Biopsy Reports, Pathology Reports, Surgical Pathology Report",
    documentLabel: "{{dateOfEvent}} Pathology Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "ushv-ccoh"
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "INR",
    documentLabel: "{{dateOfEvent}} INR Lab Result",
    folder: "INR",
    folderMapping: "INR",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "ushv-ccoh"
  },
  [Classification.LAB_RESULTS_QUANTAFLO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "QuantaFlo (not by our physicians)",
    documentLabel: "{{dateOfEvent}} QuantaFlo Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_QUANTAFLO,
    group: "ushv-ccoh"
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Reyes,Leslie",
    displayName: "Legal Documents",
    documentLabel: "{{dateReceived}} Legal Document",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "ushv-ccoh"
  },
  [Classification.LEGAL_POWER_OF_ATTORNEY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "POA's (Power of Attorney)",
    documentLabel: "{{dateReceived}} Power of Attorney",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_POWER_OF_ATTORNEY,
    group: "ushv-ccoh"
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Medical Summary",
    documentLabel: "{{dateReceived}} Medical Summary",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY,
    group: "ushv-ccoh"
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "HomeHealth Service/Physician Order",
    documentLabel: "{{dateReceived}} Home Health",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "ushv-ccoh"
  },
  [Classification.MEDICAL_HISTORY_IMMUNIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Vaccine Card",
    documentLabel: "{{dateReceived}} Vaccine Card",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_IMMUNIZATION,
    group: "ushv-ccoh"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Reyes,Leslie",
    displayName: "Medical Records Release/Request",
    documentLabel: "{{dateReceived}} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ushv-ccoh"
  },
  [Classification.ORDER_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Bustamante,Marissa",
    displayName: "Ultrasound Orders from Other Physicians (TEE, Echo, Carotid, Stress Test)",
    documentLabel: "{{dateReceived}} Ultrasound Order",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_IMAGING,
    group: "ushv-ccoh"
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Lab Orders",
    documentLabel: "{{dateReceived}} Lab Order",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "ushv-ccoh"
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "All other documents",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "ushv-ccoh"
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Therapeutic Alerts",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "ushv-ccoh"
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "RX Care Considerations",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "ushv-ccoh"
  },
  [Classification.PHARMACY_RELATED_MEDICATION_LIST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Medication List",
    documentLabel: "{{dateReceived}} Medication List",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_MEDICATION_LIST,
    group: "ushv-ccoh"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Refill Authorization Requests",
    documentLabel: "{{dateReceived}} Refill Authorization Request",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "ushv-ccoh"
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Insurance Authorizations, Prior Authorization Requests, Denials, Ultrasound Authorizations",
    documentLabel: "{{dateReceived}} Prior Authorization",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "ushv-ccoh"
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Reyes,Leslie",
    displayName: "Ablation Reports, Coronary Angiography, Coronary Arterial Diagram, EP Cardioversion, Heart Cath Hospital Notes, LINQ Procedure Report",
    documentLabel: "{{dateOfEvent}} Cardiac Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ushv-ccoh"
  },
  [Classification.PROCEDURE_CARDIAC_VEIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Venous Questionnaires",
    documentLabel: "{{dateOfEvent}} Venous Report",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC_VEIN,
    group: "ushv-ccoh"
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Implantable Device Record, Pacemaker/ICD Evaluations",
    documentLabel: "{{dateOfEvent}} Device Record",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "ushv-ccoh"
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cardiac Rehab Reports/Orders",
    documentLabel: "{{dateOfEvent}} Cardiac Rehab Report/Order",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_REHAB,
    group: "ushv-ccoh"
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Sleep Study Reports (CPAP)",
    documentLabel: "{{dateOfEvent}} Sleep Study Report",
    folder: "Sleep Studies",
    folderMapping: "Sleep Studies",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ushv-ccoh"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Hospital Discharge Notes/Instructions, Inpatient/Outpatient Discharge Summary",
    documentLabel: "{{dateOfEvent}} Hospital Discharge Summary",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "ushv-ccoh"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Hospital Consult/Progress Notes (our physicians)",
    documentLabel: "{{dateOfEvent}} Hospital Consult/Progress Note",
    folder: "Hospital records",
    folderMapping: "Hospital records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_OFFICE_VISIT,
    group: "ushv-ccoh"
  },
  [Classification.PROGRESS_NOTE_OFFICE_VISIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jennings,Faith",
    displayName: "Outside Clinic Notes (notes not by our physicians)",
    documentLabel: "{{dateOfEvent}} Outside Clinic Note",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OFFICE_VISIT,
    group: "ushv-ccoh"
  },
  [Classification.PROGRESS_NOTE_PT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Physical Therapy Orders",
    documentLabel: "{{dateReceived}} Physical Therapy Order",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PT,
    group: "ushv-ccoh"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Shivam,Navya",
    displayName: "Patient Referrals",
    documentLabel: "{{dateOfReferral}} Referral",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL,
    group: "ushv-ccoh"
  }
} as const;
